import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import {
  EXPANDED_QUANTITY_WIDTH,
  ORDER_ITEM_QUANTITY_HEIGHT,
} from '@/components/quantity-selector';
import { Skeleton } from 'react-native-skeletons';
import { SMART_ORDER_LIST_ITEM_WIDTH } from './smart-order-list-item';
import { STANDARD_IMAGE_SIZE } from './orderable-item-list-item-image';
import { View } from 'react-native';

const TEXT_SPACING = 8;

export const SmartOrderListItemLoading: React.FC = () => {
  const [styles] = useStyles();

  return (
    <View style={styles.base}>
      <Skeleton height={14} spacing={TEXT_SPACING} style={styles.label} />
      <View style={styles.row}>
        <Skeleton height={STANDARD_IMAGE_SIZE} width={STANDARD_IMAGE_SIZE} />
        <View style={styles.flex}>
          <Skeleton count={2} height={14} spacing={TEXT_SPACING} />
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.flex}>
          <Skeleton count={2} height={12} spacing={TEXT_SPACING} />
        </View>
        <Skeleton
          height={ORDER_ITEM_QUANTITY_HEIGHT}
          width={EXPANDED_QUANTITY_WIDTH}
        />
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    borderColor: theme.colors.stroke,
    borderRadius: 4,
    borderWidth: 1,
    gap: 12,
    padding: 8,
    width: SMART_ORDER_LIST_ITEM_WIDTH,
  },
  flex: {
    flex: 1,
  },
  label: {
    width: '50%',
  },
  row: {
    flexDirection: 'row',
    gap: 16,
  },
}));
